import React from 'react';
import Button from '../../../../../../component/ui/Button';

export default function ParentAccountDetailHeader({ setType, accountName, setParentAccountId }) {
	return (
		<div
			className="d-flex justify-content-between align-items-center  sticky-top z-3 p-4"
			style={{ backgroundColor: '#EDEDF7', borderBottom: '1px sold #0850ea' }}
		>
			<div>
				<div className="d-flex align-items-center gap-2">
					<span className="fs-4 fw-light">Settings</span>
					<span className="fs-4 fw-light">{'>'}</span>
					<span className="fs-4 fw-light">Accounting</span>
					<span className="fs-4 fw-light">{'>'}</span>
					<span
						className="fs-4 fw-light text-primary cursor-pointer"
						onClick={() => setType('parent-account-list')}
					>
						Parent Accounts
					</span>
					<span className="fs-4 fw-light">{'>'}</span>
					<span className="fs-4 fw-light">{accountName || ''}</span>
				</div>
				<div className="fs-3 fw-bold text-black">{accountName}</div>
				<div className="fs-3 fw-light text-black">Parent Account</div>
				<div
					className="fs-5 fw-light"
					style={{ color: '#718096' }}
				>
					Manage bank accounts used for business transactions, payments, and settlements.
				</div>
			</div>
			<div className="d-flex gap-3 align-items-center">
				<Button
					type="button"
					disabled={false}
					className="btn-danger mt-0"
					close
					onClick={() => {
						setType('parent-account-list');
						setParentAccountId(null);
					}}
				/>
			</div>
		</div>
	);
}
